import { Bell, Bookmark, Compass, Headphones, HelpCircle, Home, Info, Menu, MessageCircle, PenLine, Plus, PlusSquare, Search, Settings, UserRound, Video, X } from "lucide-react";
import { useState } from "react";
import type { UserSummary } from "../../shared/types";
import { Brand } from "../components/Brand";
import { Composer } from "../components/Composer";
import { ThemeToggle } from "../components/ThemeToggle";

const nav = [
  ["/", Home, "Home"],
  ["/search", Search, "Search"],
  ["/explore", Compass, "Explore"],
  ["/flips", Video, "Flips"],
  ["/messages", MessageCircle, "Messages"],
  ["/notifications", Bell, "Notifications"],
  ["/saved", Bookmark, "Saved"],
  ["/@pilot", UserRound, "Profile"]
] as const;

const drawerItems = [
  [Video, "Flips", "/flips", true],
  [MessageCircle, "Messages", "/messages", true],
  [Settings, "Settings", "#", false],
  [Headphones, "Support", "#", false],
  [Info, "About", "#", false],
  [PenLine, "Legals", "#", false],
  [HelpCircle, "FAQ", "#", false],
  [MessageCircle, "Give feedback", "#", false]
] as const;

export function Shell({ children, preview, user }: { children: React.ReactNode; preview?: boolean; user?: UserSummary | null }) {
  const [composer, setComposer] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const profileHref = user ? `/@${user.username}` : "/login";
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <Brand onColor />
        <nav>
          {nav.map(([href, Icon, label]) => {
            const target = label === "Profile" ? profileHref : href;
            const locked = label === "Messages" || label === "Flips";
            return <a className={location.pathname === target ? "current" : ""} href={target} key={href}><Icon size={22} /><span>{label}</span>{locked && <small>Coming Soon</small>}</a>;
          })}
          <button onClick={() => setComposer(true)}><PlusSquare size={22} /><span>Post</span></button>
        </nav>
        {!user && <a className="signin-pill" href="/login">Sign in</a>}
        <ThemeToggle />
      </aside>
      <header className="mobile-top"><button aria-label="Open menu" onClick={() => setDrawer(true)}><Menu /></button><Brand compact={false} /><div><a href="/notifications"><Bell /></a><a href="/messages"><MessageCircle /></a></div></header>
      {drawer && <div className="drawer-backdrop" onClick={() => setDrawer(false)}><aside className="mobile-drawer" onClick={(event) => event.stopPropagation()}><button className="drawer-close" onClick={() => setDrawer(false)} aria-label="Close menu"><X /></button><div className="drawer-brand"><Brand compact onColor /><h2>Welcome to Floptropica</h2></div><nav>{drawerItems.map(([Icon, label, href, locked]) => <a href={href} key={label}><Icon size={22} />{label}{locked && <small>Coming Soon</small>}</a>)}</nav><div className="drawer-pages"><span>Your pages</span><a href={profileHref}><img src={user?.avatarUrl || "/assets/floptropica-one-logo.png"} alt="" />{user?.displayName || "Create profile"}</a><a href="/signup"><Plus /> Add new page</a></div></aside></div>}
      {preview && <div className="preview-indicator">Floptropica One - Preview</div>}
      <main>{children}</main>
      <nav className="mobile-nav">
        <a href="/"><Home /></a><a href="/explore"><Compass /></a><button onClick={() => setComposer(true)} aria-label="Post"><PlusSquare /></button><a href="/flips"><Video /></a><a href={profileHref}><UserRound /></a>
      </nav>
      <Composer open={composer} onClose={() => setComposer(false)} />
    </div>
  );
}
